import { Box } from '@mui/material';
import {
  StyledDescription,
  StyledSection,
  StyledTitle,
} from '../AiKnowledgeManagementSolutions.styles';
import { whyChooseData } from './WhyChoose.data';
import {
  WhyChooseStyledTableAligner,
  WhyChooseStyledTableWrapper,
} from './WhyChoose.styles';

export const WhyChoose = () => {
  return (
    <StyledSection width="small">
      <StyledTitle variant="display_sm">
        Why Choose Custom Engineering?
      </StyledTitle>
      <StyledDescription
        variant="regular_500"
        display="inline-block"
        width="100%"
        textAlign="center">
        Platform subscriptions vs. true ownership
      </StyledDescription>

      <Box mt={4}>
        <WhyChooseStyledTableAligner>
          <WhyChooseStyledTableWrapper>
            <table>
              <thead>
                <tr>
                  {whyChooseData.headers.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {whyChooseData.rows.map((row, index) => (
                  <tr key={index}>
                    <td
                      dangerouslySetInnerHTML={{
                        __html: row.knowledgePlatforms,
                      }}
                    />
                    <td dangerouslySetInnerHTML={{ __html: row.rumbleFish }} />
                  </tr>
                ))}
              </tbody>
            </table>
          </WhyChooseStyledTableWrapper>
        </WhyChooseStyledTableAligner>
      </Box>
    </StyledSection>
  );
};
